import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Manifesto from "./components/Manifesto";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import DownloadCTA from "./components/DownloadCTA";
import Footer from "./components/Footer";
import LegalPage from "./pages/LegalPage";
import { privacySections, termsSections } from "./pages/legalData";

const Home = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <Stats />
            <Manifesto />
            <Testimonials />
            <FAQ />
            <DownloadCTA />
        </main>
        <Footer />
    </>
);

const HomeRedirect = () => <Navigate to="/" replace />;

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            setTimeout(() => {
                const el = document.querySelector(hash);
                if (el) {
                    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
                    else el.scrollIntoView({ behavior: "smooth" });
                }
            }, 300);
        } else {
            window.scrollTo(0, 0);
            if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        }
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        if (window.matchMedia("(max-width: 768px)").matches) return;
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollManager />
            <Routes>
                <Route
                    path="/"
                    element={
                        <div className="min-h-screen bg-paper font-body text-ink antialiased" data-testid="app-root">
                            <Home />
                        </div>
                    }
                />
                <Route
                    path="/privacy"
                    element={
                        <LegalPage
                            title="Privacy Policy"
                            updated="August 13, 2026"
                            sections={privacySections}
                            testid="privacy-page"
                        />
                    }
                />
                <Route
                    path="/terms"
                    element={
                        <LegalPage
                            title="Terms of Service"
                            updated="August 13, 2026"
                            sections={termsSections}
                            testid="terms-page"
                        />
                    }
                />
                <Route path="*" element={<HomeRedirect />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
